@use '@/scss/underscore' as _;

.terms {
  margin-bottom: _.unit(4);
}
